import { useDisplayExperimentalFeature, ExperimentalFeature } from '../../../hooks/useDisplayExperimentalFeature'
import { FilterApplicability, TLiveEventsCommonFilters, LiveEventsCommonFiltersData } from '../types/LiveEventsCommonFilters'

export const useLiveEventCommonFilterCounts = ({
  filters,
  data,
  hdGameSelected,
  filterApplicability,
}: {
  filters: TLiveEventsCommonFilters
  data: LiveEventsCommonFiltersData
  hdGameSelected: boolean
  filterApplicability?: FilterApplicability
}) => {
  const displayExperimentalFeatureMotivations = useDisplayExperimentalFeature(ExperimentalFeature.LiveEventMotivations) // NOTE: Remove check when we want to release Live Event Motivations

  const applicableTagsCount = filterApplicability?.liveEventTags
    ? data.liveEventTags.filter((tag) => filterApplicability.liveEventTags![tag.id] !== false).length
    : data.liveEventTags.length

  const applicableSecondaryTagsCount = filterApplicability?.liveEventSecondaryTags
    ? data.liveEventSecondaryTags.filter((tag) => filterApplicability.liveEventSecondaryTags![tag.id] !== false).length
    : data.liveEventSecondaryTags.length

  if (displayExperimentalFeatureMotivations) {
    const applicableMotivationsCount = filterApplicability?.motivations
      ? data.motivations.filter((m) => filterApplicability.motivations![m] !== false).length
      : data.motivations.length

    const applicableArchetypesCount = filterApplicability?.archetypes
      ? data.archetypes.filter((a) => filterApplicability.archetypes![a] !== false).length
      : data.archetypes.length

    const activeCount =
      filters.liveEventTags.length +
      filters.liveEventSecondaryTags.length +
      Object.keys(filters.additionalDatas).length +
      Object.keys(filters.liveEventDurations).length +
      Object.keys(filters.liveEventAppearances).length +
      (hdGameSelected ? Object.keys(filters.liveEventPricePoints).length : 0) +
      Object.keys(filters.motivations).length +
      Object.keys(filters.archetypes).length
    const maxCount =
      applicableTagsCount +
      applicableSecondaryTagsCount +
      data.additionalDatas.length +
      data.liveEventAppearances.length +
      data.liveEventDurations.length +
      (hdGameSelected ? data.liveEventPricePoints.length : 0) +
      applicableMotivationsCount +
      applicableArchetypesCount
    return {
      activeCount,
      maxCount,
    }
  }

  const activeCount =
    filters.liveEventTags.length +
    filters.liveEventSecondaryTags.length +
    Object.keys(filters.additionalDatas).length +
    Object.keys(filters.liveEventDurations).length +
    Object.keys(filters.liveEventAppearances).length +
    (hdGameSelected ? Object.keys(filters.liveEventPricePoints).length : 0)

  const maxCount =
    applicableTagsCount +
    applicableSecondaryTagsCount +
    data.additionalDatas.length +
    data.liveEventAppearances.length +
    data.liveEventDurations.length +
    (hdGameSelected ? data.liveEventPricePoints.length : 0)

  return {
    activeCount,
    maxCount,
  }
}
